import {
  getPercentSchema,
  getSelectSchema,
  getBooleanSchema,
  getStringSchema,
} from 'src/compass/shared/schemas';
import * as Yup from 'yup';
import UniqueAgentSchema from './UniqueAgentSchema';

// Custom validation function to check sum of ratePercent in asOfSplits
const validateAsOfSplitsSum = (value: any, context: any) => {
  const parentContext = context.parent;

  const anyNullorNaN = value?.some(
    (item: any) =>
      item.ratePercent === null || Number.isNaN(item.ratePercent) || item.agentId === null
  );

  if (!parentContext || !parentContext.totalRatePercent || anyNullorNaN) {
    return true;
  }

  const { totalRatePercent } = parentContext;
  const sumOfRatePercent = value.reduce((sum: any, split: any) => sum + split.ratePercent, 0);

  const roundedSum = parseFloat(sumOfRatePercent.toFixed(3));

  if (roundedSum !== totalRatePercent) {
    return false;
  }
  return true;
};

export const AsOfSplitsSchema = UniqueAgentSchema.test(
  'sum-of-ratePercent',
  'Sum of rate percents should be equal to commission rate.',
  validateAsOfSplitsSum
).of(
  Yup.object().shape({
    ratePercent: getPercentSchema('Rate Percent'),
    agentId: getSelectSchema('Agent'),
  })
);

export const LRPScheduleSchema = Yup.object().shape({
  servicingAgentId: getSelectSchema('Relationship Owner'),
  isActive: getBooleanSchema('Active', true),
  description: getStringSchema(50, 'Description').nullable(),
  asOf: Yup.object({
    totalRatePercent: getPercentSchema('Commission Rate'),
    isSplit: getBooleanSchema('Split with other agents?', false),
    asOfSplits: Yup.array().when('isSplit', (isSplit, schema) =>
      isSplit[0]
        ? AsOfSplitsSchema
        : // when isSplit is false, we will pass asOfSplits as empty array with transform function.
          Yup.array().transform(() => [])
    ),
  }),
});
